import React, { useState, useEffect, useRef } from 'react';
import { PlaceholderAnimation } from './style/tile.style';

export default function RmInput({ value: propValue, autoFocus, onChange, placeholder, type, name, display, readOnly, disabled, style }) {
    const [value, setValue] = useState(propValue ?? '');
    const [inputHasFocus, setInputHasFocus] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        setValue(propValue ?? '');
    }, [propValue]);

    useEffect(() => {
        if (autoFocus) inputRef.current?.focus();
    }, [autoFocus]);

    const isEmpty = value.length === 0;
    const placeholderStyle = {
        fontSize: isEmpty ? '14px' : '12px',
        color: isEmpty ? 'rgba(255, 255, 255, 0.7)' : 'rgba(247, 191, 61, 0.8)',
        paddingTop: isEmpty ? '15px' : '0px',
        position: 'absolute', left: 0, top: 0, zIndex: 1,
    };

    return (
        <div style={{ display, height: '34px', position: 'relative', ...style }}>
            <PlaceholderAnimation style={placeholderStyle}>{placeholder}</PlaceholderAnimation>
            <input
                type={type}
                ref={inputRef}
                name={name}
                readOnly={readOnly}
                disabled={disabled}
                style={{
                    marginLeft: '0px', height: '34px', lineHeight: '34px', borderStyle: 'none', paddingTop: '15px',
                    borderRadius: 0,
                    borderBottom: inputHasFocus ? '1px solid rgba(247, 191, 61, 0.4)' : '1px solid #c3c3c366',
                    color: 'white', backgroundColor: '#33333366',
                    position: 'absolute', top: 0, left: 0, zIndex: 2, width: '100%', paddingLeft: 0,
                }}
                value={value}
                onChange={onChange}
                onFocus={() => setInputHasFocus(true)}
                onBlur={() => setInputHasFocus(false)}
            />
        </div>
    );
}

RmInput.defaultProps = {
    placeholder: '',
    type: 'text',
    name: 'unnamed',
    display: 'block',
    readOnly: false,
    autoFocus: false,
    disabled: false,
};
